import * as React from 'react';
import { Link } from 'react-router-dom';
import teamMembers from 'src/modules/our-team/teamMembers';

interface TeamMemberComponentProps {
  match: {
    params: {
      teamMember: string;
    }
  };
}

const TeamMemberComponent = (props: TeamMemberComponentProps) => {
  const member = teamMembers
    .find(someMember => (
      someMember.profilePath === props.match.params.teamMember
    ));

  if (member === undefined) {
    return null;
  }

  return (
    <section>
      <div className="container">
        <div className="gap-20"/>
        <div className="row">
          <div className="col-sm-12">
            <p className="text-right">
              <Link to="/nuestro-equipo">
                <span className="close pointer"/>
              </Link>
            </p>
          </div>
        </div>
        <div className="row ">
          <div className="col-sm-12 team-owl">
              <div>
                <div className="row">
                  <div className="col-sm-4">
                    <img
                      alt={member.name}
                      src={member.imagePath}
                    />
                  </div>
                  <div className="col-sm-8">
                    <h5 className="deco-title">
                      {member.name}
                      ,
                      <br/>
                      <span className="primary-font f-w-100">
                        {member.title}
                      </span>
                    </h5>
                    <p style={{whiteSpace: 'pre-wrap'}}>
                      {member.description}
                    </p>

                  </div>
                </div>
                <div className="gap-20"/>
              </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamMemberComponent;


// WEBPACK FOOTER //
// ./src/modules/our-team/show/TeamMember.component.tsx